import addPopover from "../dom/addPopover";

export default function addBottomsupPopover() {
	addPopover(
		"Bottomsup",
		".pplr-script-text .pplr-selecter-options .pplr_bottomsup",
		"BOTTOMSUP",
		'<img src="https://cdn.shopify.com/s/files/1/0324/9592/7429/files/Untitled-1.jpg?v=1720037739" width="153" height="117" style="width:100%" />',
		"right",
		"ml-2",
	);
}
